const GiftBoxEvents = {
  OnGiftSend: 'OnGiftSend',
  OnGiftReceived: 'OnGiftReceived',
  OnGiftCancelled: 'OnGiftCancelled',
  WasGiftCancelled: 'WasGiftCancelled',
  WasGiftReceived: 'WasGiftReceived',
  IsGiftAlreadyExist: 'IsGiftAlreadyExist',
  OnCommissionPriceChanged: 'OnCommissionPriceChanged',
  OnValueUnderCommission: 'OnValueUnderCommission'
}

export default GiftBoxEvents



// WEBPACK FOOTER //
// ./src/services/GiftBoxEvents.js